import { FC } from "react";

const BRAND = "#2563eb";

const Hero: FC = () => {
  return (
    <div style={{
      textAlign: "center", padding: "72px 40px 56px",
      background: "linear-gradient(160deg, #eff6ff 0%, #fff 55%)",
    }}>
      {/* Headline */}
      <h1 style={{ fontSize: 52, fontWeight: 700, marginBottom: 18, letterSpacing: -1, lineHeight: 1.1 }}>
        We make <span style={{ color: BRAND }}>PDF easy.</span>
      </h1>

      {/* Subtext */}
      <p style={{ fontSize: 18, color: "#666", maxWidth: 500, margin: "0 auto 32px", lineHeight: 1.7 }}>
        All the tools you'll need to be more productive and work smarter with documents.
      </p>

      {/* CTA Buttons */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, justifyContent: "center" }}>
        <button style={{
          background: "transparent", color: "#555",
          border: "1px solid #ddd", borderRadius: 10,
          padding: "13px 28px", fontSize: 16, cursor: "pointer", transition: "all 0.15s",
        }}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = BRAND; e.currentTarget.style.color = BRAND; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#ddd"; e.currentTarget.style.color = "#555"; }}>
          Explore all tools →
        </button>
      </div>

      {/* Social proof */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 28, marginTop: 40, fontSize: 13, color: "#999" }}>
        {/*<span>⭐ 4.9/5 on TrustPilot</span>*/}
        {/*<span style={{ color: "#e0e0e0" }}>|</span>*/}
        {/*<span>🌍 1 billion+ users</span>*/}
        {/*<span style={{ color: "#e0e0e0" }}>|</span>*/}
        <span>🔒 SSL encrypted</span>
        <span style={{ color: "#e0e0e0" }}>|</span>
        <span>🆓 Always free</span>
      </div>
    </div>
  );
};

export default Hero;

